import classNames from 'classnames';
import React from 'react';
import ToolTip from '../../layout/tooltip/ToolTip';

export type TooltipItemProps = {
  children?: React.ReactNode;
  title: string;
  value: string | number;
  color?: string;
  backgroundColor?: string;
  isActive?: boolean;
  tooltipLegend?: boolean;
  classNameLabel?: string;
  classNameValue?: string;
  className?: string;
  style?: React.CSSProperties;
};

export const TooltipItem: React.FC<TooltipItemProps> = ({
  children,
  title,
  value,
  color,
  backgroundColor,
  isActive,
  tooltipLegend,
  classNameLabel,
  classNameValue,
  className,
  style,
}) => {
  const styleLabel = classNames(
    'flex items-center',
    'p-1 px-2',
    'text-xs',
    'bg-menu-active',
    'text-menu-active-text',
    'uppercase',
  );

  const styleValue = classNames(
    'flex',
    'p-1 px-2',
    'text-sm font-bold',
    'text-center',
    'text-menu-text bg-app-panel-dark',
    'items-center',
  );

  return (
    <ToolTip
      label={title}
      value={String(value)}
      classNameLabel={classNames(styleLabel, classNameLabel)}
      classNameValue={classNames(styleValue, classNameValue)}
      className={className}
      style={style}
    >
      {tooltipLegend && (
        <div
          data-component="tooltipLegend"
          className={classNames(
            'h-3 w-3 rounded-full lg:h-4 lg:w-4 ltr:mr-2 rtl:ml-2',
            isActive ? '' : 'border-2',
            backgroundColor ? '' : 'border-menu border-4',
          )}
          style={{
            borderColor: isActive ? color : '#1f2326',
            background: backgroundColor,
          }}
        />
      )}
      {children}
    </ToolTip>
  );
};
